var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOnTrack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 8C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8C0 3.58172 3.58172 0 8 0C12.4183 0 16 3.58172 16 8ZM1.58133 8C1.58133 11.5449 4.45507 14.4187 8 14.4187C11.5449 14.4187 14.4187 11.5449 14.4187 8C14.4187 4.45507 11.5449 1.58133 8 1.58133C4.45507 1.58133 1.58133 4.45507 1.58133 8Z",
    fill: "#FEDF00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4622 10.4828C13.0187 11.4586 12.3219 12.2977 11.4443 12.913C10.5666 13.5282 9.54021 13.8972 8.47171 13.9814C7.40322 14.0657 6.33165 13.8622 5.36843 13.3921C4.40521 12.922 3.58549 12.2025 2.99451 11.3083C2.40352 10.4142 2.06284 9.37803 2.00789 8.30762C1.95294 7.23722 2.18572 6.17163 2.68203 5.22166C3.17834 4.27168 3.92006 3.47199 4.83008 2.90573C5.7401 2.33947 6.78519 2.02731 7.8567 2.00171L8 8L13.4622 10.4828Z",
    fill: "#FDC72E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnTrack);
export default __webpack_public_path__ + "static/media/on_track.f1f359299a3d7b49ec2ee2ec857b9151.svg";
export { ForwardRef as ReactComponent };